import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'rpf-links',
  styleUrl: 'rpf-links.scss',
  shadow: true,
})
export class RpfLinks {
  @Prop() links: string;

  render() {
    const parsedLinks = JSON.parse(this.links);
    const currentPath = window.location.pathname;

    return (
      <Host>
        <ul class="rpf-links">
          {parsedLinks.map(link => (
            <li class="rpf-links__list-item">
              <a
                class={`rpf-links__link ${currentPath.includes(link.url) ? 'active' : ''}`}
                href={link.url}
                data-event-action="click"
                data-event-category="Header: Navigation"
                data-event-label={link.text}
                data-section={link.text.toLowerCase()}
              >
                {link.text}
              </a>
            </li>
          ))}
        </ul>
      </Host>
    );
  }
}
